import { client, request } from "./_base";

const endpoint = "piinstruction";

// extended methods
export const FindByOrderId = (orderId) => {
  return request(`${endpoint}/findByOrderId/${orderId}`, {
    method: "GET",
  })
    .then(async (result) => {
      if (result.status == 500) {
        const resp = await result.json();
        throw resp;
      }
      return result.json();
    })
    .then(({ data }) => {
      return data;
    });
};

export const piinstructions = {
  ...client<Partial<PIInstruction>>(endpoint, (item) => ({
    ...item,
  })),
  FindByOrderId: FindByOrderId,
};

export type PIInstruction = {
  id?: number;
  piorder_id: number;
  groupnum?: number | null;
  groupline?: number | null;
  volume?: string | null;
  target_id?: number | null;
  class?: string | null;
  count?: string | null;
  countconstraint?: string | null;
  coldroom?: string | null;
  brand?: string | null;
  inventory?: string | null;
  mgp?: string | null;
  fob?: string | null;
  rangemin?: string | null;
  rangemax?: string | null;
  dip?: string | null;
  dipmin?: string | null;
  dipmax?: string | null;
  tcgrouped?: number | null;
  comment?: string | null;
  rowKey?: number | null; // Decimal(19,2) can be represented as number or string if precision matters
  conventional?: number | null;
  pack_id?: number | null;
  label_id?: number | null;
};

export const updateInstructions = async (data: PIInstruction[]): Promise<void> => {
  const result = await request(`${endpoint}/ext/updateInstructions`, {
    method: "POST",
    body: JSON.stringify(data),
  });
  if (result.status == 500) {
    const resp = await result.json();
    throw resp;
  }
};
